import Vue from 'vue'
import VueI18n from 'vue-i18n'

const language = window.config ? window.config.language : 'en'

Vue.use(VueI18n)

function loadLocales() {
  const locales = require.context('../../static/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

export default new VueI18n({
  locale: language,
  fallbackLocale: 'en',
  messages: loadLocales()
})



// WEBPACK FOOTER //
// ./src/plugins/locale.js